export default __webpack_public_path__ + "static/media/dead_ley_line_branch.9d84b0f3.png";